/**
 * Utility for translations outside of the react components
 * @param {string} lang language of the active user
 * @param {string} node module name translations
 * @returns function
 */
const utilTranslations = (lang = 'de', node = null) => {
  let langFile = require(`../assets/i18n/${lang}.json`);
  if (!langFile.hasOwnProperty(node)) {
    throw new Error('Invalid translation data');
  }
  const translate = (key, values = {}) => {
    try {
      let translated = langFile[node][key] ? langFile[node][key] : `${node}.${key}`;

      //Substitute hardcoded strings
      if (Object.keys(values).length) {
        for (let text in values) {
          translated = translated.replace(`{{${text}}}`, values[text]);
        }
      }

      return translated;
    } catch (error) {
      return key;
    }
  };
  return translate;
}

export default utilTranslations;